export default __webpack_public_path__ + "static/media/checkmark2.e36210c8.png";